export const SHARE_SOCIETE_POINTS_BY_VARIANT: Record<string, number> = {
  variant_10: 10,
  variant_50: 50,
}
